$(document).ready(function () {
    const isHeader = document.querySelector('#header')
    const isMobile = document.querySelector('.mobile')

    if (isHeader) {
        if (isMobile) {
            const intervalId = setInterval(isMeBonus, 100)

            function isMeBonus() {
                const meBonusHeader = document.querySelector('.mehub-bonus-header-container')

                if (meBonusHeader) {
                    clearInterval(intervalId)

                    const navContacts = document.querySelector('#header .top-navigation-contacts')

                    if (navContacts) {
                        navContacts.insertAdjacentElement('beforeend', meBonusHeader)
                        meBonusHeader.classList.add('visible-block')
                    }
                }
            }
        }
    }
})

if($('header#header').length){
    if ($("body:not(.ordering-process)").length) {
        var navigationPosition = $(".header-top").outerHeight()+$(".header-top").offset().top;
        $(window).on("scroll", function () {
        var scrollTop = $(this).scrollTop();
        if (scrollTop >= navigationPosition) {
            $("body").addClass("navigationFixed");
        } else {
            $("body").removeClass("navigationFixed");
        }
        });
  }
}
